export const GROUPED_BETTING_TYPES = [
	"handicap-hcp",
	"over-under",
	"1st-half-totals",
	"2nd-half-over-under",
	"2nd-half-totals",
	"over-under-home-team",
	"over-under-away-team",
	"1st-half-competitor1-total",
	"1st-half-competitor2-total",
];
